import React from 'react';
import { GPTAds } from '@/tracking/ads/GPTAds';
import { AdPositions } from '@/tracking/ads/types';
import { AdUnit, AdUnitClasses } from '@/tracking/ads/components/AdUnit';

export const NewsLetterPopup = () => (
  <AdUnit
    generator={GPTAds[AdPositions.Popup]}
    className={AdUnitClasses.popup}
  />
);
